'use strict';

    angular
        .module('virtualFairs')
        .controller('AccountCreateController', AccountCreateController)

    AccountCreateController.$inject = ['$uibModal', '$scope','$http', 'API_BASE', '$state','toastr','$stateParams', 'countries', 'timezones'];

    function AccountCreateController( $uibModal, $scope, $http, API_BASE, $state, toastr, $stateParams, countries, timezones) {
        var vm = this;
        vm.save = save;
        vm.getEntityType = getEntityType;
        vm.getFormView = getFormView;
        vm.checkboxValidator = checkboxValidator;
        vm.uploadPhoto = uploadPhoto;
        vm.uploadHandler = uploadHandler;
        vm.imageCrop = imageCrop;
        vm.entity = {
            user: {
                email: '',
                type: $stateParams.type,
            },
            profile: {
                name: '',
            },
            video_url: ''
        };
        vm.croppedImage = '';

        vm.countries = countries;
        vm.timezones = timezones;

        switch (vm.entity.user.type) {
            case 'government':
                /* Do nothing */
                break;
            case 'agency':
                /* Do nothing */
                break;
            case 'institution':
                console.log('teste')
                vm.entity.profile.show_contact = false;
                vm.entity.user.preferences = [
                    {
                        name: 'Students',
                        value: 'relationship_with_students'
                    },
                    {
                        name: 'Schools',
                        value: 'relationship_with_institutions'
                    },
                    {
                        name: 'Study Abroad Agencies',
                        value: 'relationship_with_agents'
                    },
                ];
                vm.entity.profile.institutions_profile_types = [
                    {
                        name: "Secondary Schools / Boarding Schools",
                        value: 'boarding'
                    },
                    {
                        name: "Bachelor's / Bachelor of Science / Community College / College / Technical",
                        value: 'university'
                    },
                    {
                        name: "Master's / PhD / Specialized Master's",
                        value: 'graduate'
                    },
                    {
                        name: "MBA Programs",
                        value: 'mba'
                    },
                    {
                        name: "Short term / University credit program / Extension",
                        value: 'extension'
                    },
                    {
                        name: "Language Courses",
                        value: 'language'
                    },
                    {
                        name: "Online Distance Learning",
                        value: 'online'
                    },
                    {
                        name: "Vocational / Career / Technical",
                        value: 'vocational'
                    },
                ];
                break;
            case 'other':
                vm.entity.user.others_services_for_students = [
                    {
                        name: 'Airline tickets',
                        id: '2'
                    },
                    {
                        name: 'Associations and Consortiums',
                        id: '24'
                    },
                    {
                        name: 'Currency house (exchange/sell)',
                        id: '18'
                    },
                    {
                        name: 'Education Resources',
                        id: '22'
                    },
                    {
                        name: 'Immigration Services',
                        id: '17'
                    },
                    {
                        name: 'Insurance Services',
                        id: '21'
                    },
                    {
                        name: 'Medical Assistance',
                        id: '9'
                    },
                    {
                        name: 'Student Housing',
                        id: '20'
                    },
                    {
                        name: 'Visa broker',
                        id: '19'
                    },
                    {
                        name: 'Work Abroad',
                        id: '16'
                    }
                ];
                break;
            default:
                /* Do nothing */
                break;
        }

        function save() {
            var fields = angular.copy(vm.entity);
            fields.user.profile_picture = vm.croppedImage;
            
            switch (fields.user.type) {
                case 'government':
                    fields.profile.represent_country = fields.profile.represent_country.id;
                    fields.profile.timezone_name = fields.profile.timezone_name;
                    fields.profile.based_country = fields.profile.based_country.id;
                    fields.profile.description_students = fields.profile.description;
                    delete fields.profile.description;
                    break;
                case 'agency':
                    var gmapsInfo = vm.entity.profile.city;
                    fields.profile.timezone_name = fields.profile.timezone_name;
                    fields.profile.description_students = fields.profile.description;
                    delete fields.profile.description;

                    fields.profile.place_id = gmapsInfo.place_id;
                    fields.profile.city = gmapsInfo.vicinity;
                    fields.profile.countries_id = gmapsInfo.address_components.filter(comp => comp.types.includes('country'))[0].short_name;
                        
                    break;
                case 'institution':
                    fields.profile.countries_id = fields.profile.countries_id.id;
                    fields.profile.timezone_name = fields.profile.timezone_name;
                    fields.user.preferences = fields.user.preferences.reduce(function(preferences, preference, i) {
                        if (preference.selected) {
                            preferences.push(preference.value);
                        }
                        return preferences;
                    }, new Array());
                    fields.profile.institutions_profile_types = fields.profile.institutions_profile_types.reduce(function(types, type, i) {
                        if (type.selected) {
                            types.push(type.value);
                        }
                        return types;
                    }, new Array());
                    break;
                case 'other':
                    fields.profile.countries_id = fields.profile.countries_id.id;
                    fields.profile.timezone_name = fields.profile.timezone_name;
                    fields.user.others_services_for_students = fields.user.others_services_for_students.reduce(function(services, service, i) {
                        if (service.selected) {
                            services.push(service.id);
                        }
                        return services;
                    }, new Array());
                    break;
                default:
                    /* Do nothing */
                    break;
            }

            $http({
                method: 'POST',
                url: API_BASE + '/users_accounts',
                headers: { 'Content-Type': 'application/json; charset=UTF-8' },
                data: fields,
            }).then(function (res) {
                toastr.success('Account successfully created.');
                // $state.go('root.virtualfair.preRegistrations.register', {userId : res.data.id, prId : preApprovedItem.id}, {reload:true});
                // $state.go('root.edufindme.createAccount', {type: $stateParams.type});
                $state.go($state.current, {type: $stateParams.type}, {reload: true});
                // vm.getByFilter();
                vm.cancel();
            }).catch(function (res) {
                if(typeof res.data !== undefined && typeof res.data.message !== undefined) {
                    switch (res.data.message) {
                        case 'SQLSTATE[23000]':
                            toastr.error('E-mail already taken, please use another one.');
                            break;
                        default:
                            toastr.error('Something went wrong. Please try again later.');
                            break;
                    }
                }
            });
        }
        
        function checkboxValidator(checkboxGroup) {
            return !checkboxGroup.filter(function(service) {
                return service.selected;
            }).length;
        };
        
        function getEntityType() {
            return vm.entity.user.type;
        }
        
        function getFormView() {
            return 'templates/edufindme/create-account/' + vm.entity.user.type + '/form.html';
        }

        function uploadPhoto() {
            angular.element('#accountProfilePhoto').trigger('click');
        }

        function uploadHandler(e) {
            if (e.currentTarget.files.length) {
                var file = e.currentTarget.files[0];
                var reader = new FileReader();
                reader.onload = function (e) {
                    $scope.$apply(function() {
                        vm.imageCrop(e.target.result);
                    });
                };
                reader.readAsDataURL(file);
            }
            angular.element(e.target).val(null);
        }    

        function imageCrop(uploaded) {
            $uibModal.open({
                size: 'sm',
                backdrop  : 'static',
                templateUrl: 'templates/physicalfairs/reports/pre-registrations/account/form/crop.modal.html',
                controller: ['$uibModalInstance', function ($uibModalInstance) {
                    var cropModal = this;
                    cropModal.cancel = $uibModalInstance.close;
                    cropModal.save = save;
                    cropModal.uploaded = uploaded;

                    function save() {
                        vm.croppedImage = cropModal.cropped;
                        cropModal.cancel();
                    }
                }],
                controllerAs: 'cropModal',
            });
        }
    }   
